import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import Select, { createFilter } from "react-select";
import {
  API_URL_costos,
  API_URL_partidas,
  API_URL_productos,
  API_URL_vendors,
  API_URL_partners,
} from "../../../constants";

import { getAuthHeaders } from "../../../utils/auth";

class ProyectoPartidaFrom extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pk: '',
      partida: '',
      // Precio Unitario defaults to 0 — most partidas (comisiones especially)
      // are cost-only and don't have a per-unit price. Users kept having to
      // manually clear the required-looking blank field with a "0".
      precio: 0,
      costo: '',
      errorMessage: "",
      proyecto_code: "",
      asignado:"",
      asignadoList: [],
      isMaterialesDigitalesSelected: false,
      isInstructorSelected: false,
      isProveedorSelected: false,
      miembro_asignado:'',
      productos: [],
      vendors: [],
      partners: [],
      proveedor: '',
      cantidad: 1,
      totalCost: '',
      productosDigtiales: [],
      productosImpresos: [],
      porcentajeComision: '',
      tipo_cambio: null,
      validationErrors: {},
      isSubmitting: false
    };
  }

  // A partida is treated as a "comisión de venta" when its name starts with
  // "Comision" / "Comisión" — tolerant of accent, plural, and casing variants
  // that have shown up in the Costos catalog.
  isComisionVenta = (partidaName) => {
    const n = (partidaName || '').toString().toLowerCase();
    return n.startsWith('comisi');
  };

  componentDidMount() {
    // Inherit currency from project
    const proyectoMoneda = this.props.proyectoMoneda || 'USD';

    if (this.props.partida) {
      const {
        pk,
        partida,
        precio,
        costo,
        proyecto_code,
        referencia,
        asignado,
        isMaterialesDigitalesSelected,
        isProveedorSelected,
        miembro_asignado,
        productos,
        cantidad,
        proveedor,
        tipo_cambio,
      } = this.props.partida;

      // Back-compute Porcentaje de Comisión when editing a comisión partida
      // so the helper input hydrates instead of resetting to 0.
      // On save the % is not persisted (only the resulting costo is), so we
      // reverse the formula: pct = costo ÷ ingreso × 100.
      let porcentajeComision = '';
      if (this.isComisionVenta(partida)) {
        const ingreso = Number(this.props.ingresoProyecto) || 0;
        const costoNum = Number(costo) || 0;
        if (ingreso > 0 && costoNum > 0) {
          porcentajeComision = Number(((costoNum / ingreso) * 100).toFixed(2));
        }
      }

      this.setState({
        pk,
        partida,
        precio,
        costo,
        moneda: proyectoMoneda,
        tipo_cambio: tipo_cambio ?? null,
        proyecto_code,
        referencia,
        asignado,
        isMaterialesDigitalesSelected,
        isInstructorSelected: miembro_asignado !== '',
        isProveedorSelected,
        miembro_asignado,
        productos,
        cantidad,
        porcentajeComision,
        totalCost: (cantidad || 0) * (costo || 0),
        totalPrice: (cantidad || 0) * (precio || 0),
        proveedor,
      }, () => {
        const headers = getAuthHeaders();
        axios.get(API_URL_productos, { headers })
          .then((response) => {
            const productos = response.data;
            const filteredProductosDigital = productos.filter(
              (producto) => producto.tipo === 'Material Digital' || producto.tipo === 'Libro digital'
            );
            const filteredProductosImpreso = productos.filter(
              (producto) => producto.tipo === 'Material impreso'
            );
  
            if (this.state.asignado === 'Proveedor') {
              this.setState({
                isProveedorSelected: true,
              });
            }
  
            if (this.state.partida === "Materiales Digitales") {
              this.setState({
                isMaterialesDigitalesSelected: true,
                productos: filteredProductosDigital
              });
            } else if (this.state.partida === "Materiales impresos") {
              this.setState({
                isMaterialesDigitalesSelected: true,
                productos: filteredProductosImpreso
              });
            } else {
              this.setState({
                isMaterialesDigitalesSelected: false,
                productos: []
              });
            }
          })
          .catch(error => console.error("Error fetching productos:", error));
      });
    }
  
    this.getData();
    const proyectoCodeFrom = this.props.proyectoCode;
    const proyectoMonedaVal = this.props.proyectoMoneda || 'USD';
    this.setState({
      proyecto_code: proyectoCodeFrom,
      moneda: proyectoMonedaVal
    });
  }
  

  getData() {
    const headers = getAuthHeaders();

    Promise.all([
      axios.get(API_URL_partidas, { headers }),
      axios.get(API_URL_costos, { headers }),
      axios.get(API_URL_productos, { headers }),
      axios.get(API_URL_vendors, { headers }),
      axios.get(API_URL_partners, { headers }),
    ]).then(responses => {
      const [partidasResponse, costosResponse, productosResponse, vendorResponse, partnersResponse] = responses;
      this.setState({
        partidas: partidasResponse.data,
        costos: costosResponse.data,
        vendors: vendorResponse.data,
        partners: partnersResponse.data,
      });

      const allProductos = productosResponse.data;
      // Tolerant matching: DB has historically used inconsistent casing and
      // singular/plural for `tipo` (e.g. "Material impreso", "Materiales impresos",
      // "Libro digital"). Match on lowercased substring so the dropdown stays
      // populated regardless of the exact label.
      const normalizeTipo = (t) => (t || '').toString().toLowerCase();
      const filteredProductosDigital = allProductos.filter(p => normalizeTipo(p.tipo).includes('digital'));
      const filteredProductosImpreso = allProductos.filter(p => normalizeTipo(p.tipo).includes('impres'));
      this.setState({
        productosDigtiales: filteredProductosDigital,
        productosImpresos: filteredProductosImpreso,
      });
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  }

  validateForm = () => {
    const errors = {};
    const { partida, asignado, precio, costo, cantidad, moneda } = this.state;

    if (!partida || partida.trim() === '') {
      errors.partida = 'Por favor selecciona una partida';
    }

    if (!asignado || asignado.trim() === '') {
      errors.asignado = 'Por favor selecciona a quién está asignado';
    }

    if (precio !== '' && parseFloat(precio) < 0) {
      errors.precio = 'El precio no puede ser negativo';
    }

    if (!costo || costo === '') {
      errors.costo = 'Por favor ingresa el costo unitario';
    } else if (parseFloat(costo) < 0) {
      errors.costo = 'El costo no puede ser negativo';
    }

    if (!cantidad || cantidad === '') {
      errors.cantidad = 'Por favor ingresa la cantidad';
    } else if (parseFloat(cantidad) <= 0) {
      errors.cantidad = 'La cantidad debe ser mayor a 0';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  onChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      validationErrors: {
        ...this.state.validationErrors,
        [name]: null
      }
    });
  };

  onChangeNumeric = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value);

    const newValue = isNaN(numericValue) ? '' : numericValue;

    this.setState(prevState => {
      const next = {
        ...prevState,
        [name]: newValue,
        validationErrors: {
          ...prevState.validationErrors,
          [name]: null,
        },
      };

      // For Comisiones de venta, "Porcentaje de comisión" auto-fills Costo Unitario
      // as ingresoProyecto × porcentaje / 100 so users don't have to compute it.
      if (name === 'porcentajeComision' && this.isComisionVenta(prevState.partida)) {
        const ingreso = Number(this.props.ingresoProyecto) || 0;
        const pct = Number(newValue) || 0;
        next.costo = ingreso > 0 && pct > 0 ? Number((ingreso * pct / 100).toFixed(2)) : '';
        if (next.validationErrors) next.validationErrors.costo = null;
      }

      return next;
    }, () => {
      if (name === 'cantidad' || name === 'costo' || name === 'precio' || name === 'porcentajeComision') {
        const { cantidad, costo, precio } = this.state;
        const totalCost = (cantidad || 0) * (costo || 0);
        const totalPrice = (cantidad || 0) * (precio || 0);
        this.setState({ totalCost, totalPrice });
      }
      console.log(`State ${name} updated:`, this.state[name]);
    });
  }

  onChangeAsignado = e => {
    const { name, value } = e.target;
    if (value === 'Instructor') {
      this.setState({
        [name]: value,
        isInstructorSelected: true,
        isProveedorSelected: false,
        validationErrors: {
          ...this.state.validationErrors,
          [name]: null
        }
      });
    } else if (value === 'Proveedor') {
      this.setState({
        [name]: value,
        isInstructorSelected: false,
        isProveedorSelected: true,
        validationErrors: {
          ...this.state.validationErrors,
          [name]: null
        }
      });
    }
    else {
      this.setState({
        [name]: value,
        isInstructorSelected: false,
        isProveedorSelected: false,
        validationErrors: {
          ...this.state.validationErrors,
          [name]: null
        }
      });
    }
  };


  onChangePartida = e => {
    const { name, value } = e.target;
    const { productosDigtiales, productosImpresos } = this.state;
    const normalized = (value || '').toLowerCase();

    // Reset the comisión helper when switching to a partida that isn't a comisión
    if (!this.isComisionVenta(value)) {
      this.setState({ porcentajeComision: '' });
    } else {
      // Comisiones have effectively fixed shape: unit price = 0, quantity = 1.
      // Pre-fill so the form can be saved by only filling in Porcentaje.
      const { cantidad, precio } = this.state;
      const patch = {};
      if (cantidad === '' || cantidad === null || cantidad === undefined) patch.cantidad = 1;
      if (precio === '' || precio === null || precio === undefined) patch.precio = 0;
      if (Object.keys(patch).length) this.setState(patch);
    }

    if (normalized.includes('digital')) {
      this.setState({
        isMaterialesDigitalesSelected: true,
        [name]: value,
        productos: productosDigtiales,
        validationErrors: {
          ...this.state.validationErrors,
          [name]: null
        }
      });
    } else if (normalized.includes('impres')) {
      this.setState({
        isMaterialesDigitalesSelected: true,
        [name]: value,
        productos: productosImpresos,
        validationErrors: {
          ...this.state.validationErrors,
          [name]: null
        }
      });
    } else {
      this.setState({
        isMaterialesDigitalesSelected: false,
        [name]: value,
        productos: [],
        validationErrors: {
          ...this.state.validationErrors,
          [name]: null
        }
      });
    }
  };
  

  createPartida = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid-custom, .react-select-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const input = firstError.querySelector('input, select');
          if (input) input.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.post(API_URL_partidas, this.state, { headers })
    .then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
        console.log("Error adding partida:", error);

        if (error.response?.data) {
          const serverErrors = error.response.data;
          if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
            this.setState({ validationErrors: serverErrors, isSubmitting: false });
          } else {
            this.setState({
              errorMessage: 'Error al guardar la partida. Por favor verifica los datos.',
              isSubmitting: false
            });
          }
        } else {
          this.setState({
            errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
            isSubmitting: false
          });
        }
    });
  };

  editPartida = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid-custom, .react-select-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const input = firstError.querySelector('input, select');
          if (input) input.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    const url = `${API_URL_partidas}${this.state.pk}/`;
    axios.put(url, this.state, { headers })
    .then(() => {
        this.props.resetState();
        this.props.toggle();
    }).catch(error => {
        console.error("Error editing partida:", error);

        if (error.response?.data) {
          const serverErrors = error.response.data;
          if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
            this.setState({ validationErrors: serverErrors, isSubmitting: false });
          } else {
            this.setState({
              errorMessage: 'Error al actualizar la partida. Por favor verifica los datos.',
              isSubmitting: false
            });
          }
        } else {
          this.setState({
            errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
            isSubmitting: false
          });
        }
    });
  };

  defaultIfEmpty = value => {
    return value === "" ? "" : value;
  };

  defaultIfEmptyNumeric(value) {
    return value || 0;
  }

  render() {
    const {
      partida,
      errorMessage,
      costos,
      productos,
      producto,
      isMaterialesDigitalesSelected,
      isInstructorSelected,
      isProveedorSelected,
      asignado,
      miembro_asignado,
      cantidad,
      vendors,
      partners,
      validationErrors,
      isSubmitting
    } = this.state;

    const proyectoCodeFrom = this.props.proyectoCode;
    const proyectoNameFrom = this.props.proyectoName;
    const totalPrice = (this.state.precio || 0) * (cantidad || 0);
    const totalCost = (this.state.costo || 0) * (cantidad || 0);

    console.log('this.state', this.state);
    const h3Style = {
      color: 'blue'
    };

    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    const partidaOptions = Array.isArray(costos)
      ? costos.map(costo => costo.costo).sort().map(c => ({ value: c, label: c }))
      : [];

    const productoOptions = Array.isArray(productos)
      ? productos.map(p => ({ value: p.nombre, label: p.nombre }))
      : [];

    const asignadoOptions = [
      { value: "Instructor", label: "Instructor" },
      { value: "Proveedor", label: "Proveedor" },
      { value: "Sin Asignar", label: "Sin Asignar" },
    ];

    // Now using partners instead of instructores
    const partnerOptions = Array.isArray(partners)
      ? partners
          .slice()
          .sort((a, b) => (a.partner || "").localeCompare(b.partner || ""))
          .map(p => ({ value: p.partner, label: p.partner }))
      : [];

    const vendorOptions = Array.isArray(vendors)
      ? vendors.map(v => ({ value: v.vendor, label: v.vendor }))
      : [];

    const fxRowCurrency = this.state.moneda || 'USD';
    const fxProjectCurrency = this.props.proyectoMoneda || 'USD';
    const fxCurrency = fxRowCurrency !== 'USD' ? fxRowCurrency : fxProjectCurrency;
    const showTipoCambio = fxRowCurrency !== 'USD' || fxProjectCurrency !== 'USD';

    return (
      <div>
        <h3>{proyectoNameFrom}</h3>
        {proyectoCodeFrom &&
          <h3 style={h3Style}>{proyectoCodeFrom.toUpperCase()}</h3>
        }
        <div className="form-requirements-note">
          <strong>Nota:</strong> Los campos marcados con <span className="required-asterisk">*</span> son obligatorios.
        </div>
        <Form onSubmit={this.props.partida ? this.editPartida : this.createPartida}>
          <FormGroup>
            <Label for="partida">
              Selecciona Partida<span className="required-asterisk">*</span>
            </Label>
            <Select
              options={partidaOptions}
              value={partidaOptions.find((o) => o.value === partida) || null}
              onChange={(opt) => this.onChangePartida({ target: { name: 'partida', value: opt ? opt.value : "" }})}
              placeholder="Selecciona partida"
              isClearable
              filterOption={filterOption}
              className={validationErrors.partida ? 'is-invalid' : ''}
            />
            {validationErrors.partida && (
              <div className="invalid-feedback-custom">{validationErrors.partida}</div>
            )}
          </FormGroup>
          {isMaterialesDigitalesSelected && (
            <FormGroup>
              <Label for="Selecciona Materiales">Selecciona Materiales:</Label>
              <Select
                options={productoOptions}
                value={productoOptions.find((o) => o.value === producto) || null}
                onChange={(opt) => this.onChange({ target: { name: 'producto', value: opt ? opt.value : "" }})}
                placeholder="Selecciona producto"
                isClearable
                filterOption={filterOption}
              />
            </FormGroup>
          )}
          <FormGroup>
            <Label for="asignado">
              Asignado<span className="required-asterisk">*</span>
            </Label>
            <Select
              options={asignadoOptions}
              value={asignadoOptions.find((o) => o.value === asignado) || null}
              onChange={(opt) => this.onChangeAsignado({ target: { name: 'asignado', value: opt ? opt.value : "" }})}
              placeholder="Selecciona"
              isClearable
              filterOption={filterOption}
              className={validationErrors.asignado ? 'is-invalid' : ''}
            />
            {validationErrors.asignado && (
              <div className="invalid-feedback-custom">{validationErrors.asignado}</div>
            )}
          </FormGroup>
          {isInstructorSelected && (
            <FormGroup>
              <Label for="Selecciona miembro asignar">Selecciona miembro a Asignar:</Label>
              <Select
                options={partnerOptions}
                value={partnerOptions.find((o) => o.value === miembro_asignado) || null}
                onChange={(opt) => this.onChange({ target: { name: 'miembro_asignado', value: opt ? opt.value : "" }})}
                placeholder="Selecciona miembro"
                isClearable
                filterOption={filterOption}
              />
            </FormGroup>
          )}
          {isProveedorSelected && (
            <FormGroup>
              <Label for="Selecciona proveedor">Selecciona Proveedor:</Label>
              <Select
                options={vendorOptions}
                value={vendorOptions.find((o) => o.value === this.state.proveedor) || null}
                onChange={(opt) => this.onChange({ target: { name: 'proveedor', value: opt ? opt.value : "" }})}
                placeholder="Selecciona proveedor"
                isClearable
                filterOption={filterOption}
              />
            </FormGroup>
          )}
          <FormGroup>
            <Label for="precio">
              Precio Unitario
            </Label>
            <Input
              type="number"
              name="precio"
              onChange={this.onChangeNumeric}
              value={this.defaultIfEmpty(this.state.precio)}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
              className={validationErrors.precio ? 'is-invalid-custom' : ''}
            />
            {validationErrors.precio && (
              <div className="invalid-feedback-custom">{validationErrors.precio}</div>
            )}
          </FormGroup>
          {this.isComisionVenta(partida) && (
            <FormGroup>
              <Label for="porcentajeComision">
                Porcentaje de Comisión (%)
              </Label>
              <Input
                type="number"
                name="porcentajeComision"
                onChange={this.onChangeNumeric}
                value={this.defaultIfEmpty(this.state.porcentajeComision)}
                inputMode="numeric"
                step="0.01"
                min="0"
                max="100"
                placeholder="0.00"
                onWheel={(e) => e.target.blur()}
              />
              <small className="form-text text-muted">
                Ingreso del proyecto: {Number(this.props.ingresoProyecto || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {this.state.moneda || 'USD'} · el Costo Unitario se calcula como ingreso × porcentaje ÷ 100.
              </small>
            </FormGroup>
          )}
          <FormGroup>
            <Label for="costo">
              Costo Unitario<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="costo"
              onChange={this.onChangeNumeric}
              value={this.defaultIfEmpty(this.state.costo)}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
              className={validationErrors.costo ? 'is-invalid-custom' : ''}
            />
            {validationErrors.costo && (
              <div className="invalid-feedback-custom">{validationErrors.costo}</div>
            )}
          </FormGroup>
          <FormGroup>
            <Label for="costo">
              Cantidad<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="cantidad"
              onChange={this.onChangeNumeric}
              value={this.defaultIfEmpty(this.state.cantidad)}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
              className={validationErrors.cantidad ? 'is-invalid-custom' : ''}
            />
            {validationErrors.cantidad && (
              <div className="invalid-feedback-custom">{validationErrors.cantidad}</div>
            )}
          </FormGroup>
          <FormGroup>
            <Label for="totalPrice">Total Price:</Label>
            <Input
              type="text"
              name="totalPrice"
              onChange={this.onChange}
              value={totalPrice.toFixed(2)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="totalCost">Total Cost:</Label>
            <Input
              type="text"
              name="totalCost"
              onChange={this.onChange}
              value={totalCost.toFixed(2)}
            />
          </FormGroup>

          <FormGroup>
            <Label for="moneda">Moneda (desde proyecto):</Label>
            <Input
              type="text"
              name="moneda"
              value={this.state.moneda || 'USD'}
              disabled
              style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
            />
            <small className="form-text text-muted">
              La moneda se hereda del proyecto y no se puede cambiar aquí
            </small>
          </FormGroup>

          {showTipoCambio && (
            <FormGroup>
              <Label for="tipo_cambio">
                Tipo de Cambio ({fxCurrency} por 1 USD):
              </Label>
              <Input
                type="number"
                step="0.0001"
                min="0"
                name="tipo_cambio"
                placeholder="ej. 17 (vacío para usar la tasa mensual)"
                onChange={(e) => this.setState({
                  tipo_cambio: e.target.value === "" ? null : Number(e.target.value)
                })}
                value={this.state.tipo_cambio ?? ""}
              />
              <small className="form-text text-muted">
                {fxRowCurrency !== 'USD'
                  ? 'Opcional. Si lo capturas, esta partida se convierte a USD dividiendo entre este número. Vacío = tasa del mes de inicio del proyecto.'
                  : `Opcional. Si lo capturas, esta partida en USD se convierte a ${fxProjectCurrency} multiplicando por este número. Vacío = tasa del mes de inicio del proyecto.`}
              </small>
            </FormGroup>
          )}

          <FormGroup>
            <Label for="referencia">Referencia:</Label>
            <Input
              type="text"
              name="referencia"
              onChange={this.onChange}
              value={this.defaultIfEmpty(this.state.referencia)}
            />
          </FormGroup>
          
          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
          <Button color="primary" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner size="sm" className="me-2" /> Guardando...
              </>
            ) : (
              'Guardar'
            )}
          </Button>
        </Form>
      </div>
    );
  }
}

export default ProyectoPartidaFrom;